"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoomHeartBeat = void 0;
var util_1 = require("../util");
var room_channel_define_1 = require("./room-channel-define");
// 前端默认心跳间隔
var defaultHeartBeatInterval = 15000;
// 心跳发送失败重试次数
var headBeatSendMaxRetryCount = 3;
/**
 * 房间心跳消息发送管理
 *
 * @class RoomHeartBeat
 */
var RoomHeartBeat = /** @class */ (function () {
    function RoomHeartBeat(msgSender, channelOption, heartBeatDependency) {
        // 心跳间隔
        this.heartBeatInterval = defaultHeartBeatInterval;
        this.messageSender = msgSender;
        this.channelOption = channelOption;
        this.roomStatusDependency = heartBeatDependency;
    }
    RoomHeartBeat.prototype.dispose = function () {
        this.clearHeartBeatTimer();
    };
    RoomHeartBeat.prototype.startHeartBeatOnTimer = function (interval) {
        var _this = this;
        if (interval && interval !== this.heartBeatInterval) {
            this.heartBeatInterval = interval;
        }
        if (this.heartBeatTimer) {
            return;
        }
        this.heartBeatTimer = setTimeout(function () {
            _this.sendHeartBeat();
        }, this.heartBeatInterval);
    };
    /* IMessageSenderRoomHeartBeatDependency begin */
    RoomHeartBeat.prototype.onHeartBeatResponse = function (head, body) {
        var _a, _b, _c, _d;
        this.heartBeatCount = 0;
        var heartBeatInterval = ((_a = body === null || body === void 0 ? void 0 : body.onpost) === null || _a === void 0 ? void 0 : _a.heartbeat_interval) || this.heartBeatInterval;
        this.startHeartBeatOnTimer(heartBeatInterval);
        if ((_b = body === null || body === void 0 ? void 0 : body.data) === null || _b === void 0 ? void 0 : _b.common) {
            (_d = (_c = this.roomStatusDependency).heartBeatCommon) === null || _d === void 0 ? void 0 : _d.call(_c, body.data.common);
        }
    };
    RoomHeartBeat.prototype.resetHeartBeat = function () {
        this.clearHeartBeatTimer();
        this.heartBeatCount = 0;
        this.heartBeatInterval = defaultHeartBeatInterval;
    };
    RoomHeartBeat.prototype.clearHeartBeatTimer = function () {
        if (this.heartBeatTimer) {
            clearTimeout(this.heartBeatTimer);
            this.heartBeatTimer = 0;
        }
    };
    RoomHeartBeat.prototype.sendHeartBeat = function () {
        var _a;
        this.clearHeartBeatTimer();
        var roomState = (_a = this.roomStatusDependency) === null || _a === void 0 ? void 0 : _a.getRoomState();
        if (roomState !== room_channel_define_1.RoomState.OPENED || !this.messageSender) {
            util_1.ConnectionLog.warn("sendHeartBeat: room state error, state = " + roomState);
            return;
        }
        if (this.heartBeatCount > 0) {
            util_1.ConnectionLog.warn("sendHeartBeat: heart beat count over 1, count = " + this.heartBeatCount);
        }
        if (this.heartBeatCount > headBeatSendMaxRetryCount) {
            util_1.ConnectionLog.warn('sendHeartBeat: max heart beat count reached, the connection will be close.');
            this.messageSender.closeAndDelayReopen({ reason: 'closed by heart beat error.', shutDown: false }, 0);
            return;
        }
        this.heartBeatCount += 1;
        var heartBeatData = util_1.JsonUtil.jsonStringify(this.heartBeatHead) + "\n";
        this.messageSender.postMessageWithWebsocket(heartBeatData);
        this.startHeartBeatOnTimer(this.heartBeatInterval);
    };
    Object.defineProperty(RoomHeartBeat.prototype, "heartBeatHead", {
        get: function () {
            var _a, _b;
            var head = {
                type: "HEART_BEAT" /* HEART_BEAT */,
                task_id: util_1.generateMessageTaskId(),
                docid: this.channelOption.globalPadId,
                uid: this.channelOption.uid || this.channelOption.userId.replace('p.', '').replace('g.', ''),
            };
            // 将业务侧字段携带到 head里，仅做浅拷贝
            return Object.assign((_b = (_a = this.channelOption.config) === null || _a === void 0 ? void 0 : _a.heartBeatAdditionalHead) !== null && _b !== void 0 ? _b : {}, head);
        },
        enumerable: false,
        configurable: true
    });
    return RoomHeartBeat;
}());
exports.RoomHeartBeat = RoomHeartBeat;
